import {RefObject, useEffect, useState} from "react";

export const useStickyIntersection = (stickyWrapRef: RefObject<HTMLDivElement | null>) => {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        //  TODO: Analyze if it can be combined with @pg-mono/hooks/useCallbackOnIntersection
        if (!stickyWrapRef.current || !("IntersectionObserver" in window)) {
            return;
        }

        const elementHeight = stickyWrapRef.current.offsetHeight;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.boundingClientRect.top <= 0) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            },
            {rootMargin: `-1px 0px ${elementHeight}px 0px`, threshold: [0, 1]}
        );

        observer.observe(stickyWrapRef.current);

        return () => {
            if (!stickyWrapRef.current) {
                return;
            }

            observer.unobserve(stickyWrapRef.current);
        };
    }, [stickyWrapRef.current]);

    return isSticky;
};
import {RefObject, useEffect, useState} from "react";

export const useStickyIntersection = (stickyWrapRef: RefObject<HTMLDivElement | null>) => {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        //  TODO: Analyze if it can be combined with @pg-mono/hooks/useCallbackOnIntersection
        if (!stickyWrapRef.current || !("IntersectionObserver" in window)) {
            return;
        }

        const elementHeight = stickyWrapRef.current.offsetHeight;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.boundingClientRect.top <= 0) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            },
            {rootMargin: `-1px 0px ${elementHeight}px 0px`, threshold: [0, 1]}
        );

        observer.observe(stickyWrapRef.current);

        return () => {
            if (!stickyWrapRef.current) {
                return;
            }

            observer.unobserve(stickyWrapRef.current);
        };
    }, [stickyWrapRef.current]);

    return isSticky;
};
